import router from "@/routes";
let btnList = []
// 过滤出所有菜单
const filterAllMenuBtn = function (menu) {
  for (let i = 0; i < menu.length; i++) {
    if (menu[i].children && menu[i].children.length > 0) {
      filterAllMenuBtn(menu[i].children)
    }
    if (menu[i].type === 'B' || menu[i].type === 'K') {
      btnList.push(menu[i])
    }
  }
  return btnList
}
// 根据key过滤菜单按钮
const filterMenuBtn = function (data, key) {
  return !!(data && data.length > 0 ? data.find(item => item.url === key && item.hasAuth) : undefined)
}
// 根据key过滤获取编码
const getMenuBtnCode = function (data, key) {
  if (data && data.length > 0) {
    let obj = data.find(item => item.url === key && item.hasAuth)
    if (obj) {
      return obj.code
    }
  }
 
  return ''
}
// 根据url获取对应的code
const filterMenuDataAuth = function (data, url) {
  const currentRoute = router?.currentRoute
  const authUrl = url || currentRoute?.path
  let code = ''
  if (data && data.length > 0) {
    let codeArr = data.find(item => {
      return [authUrl, currentRoute?.meta?.parentAuth].includes(item.url) && item.hasAuth
    })
    if (codeArr) {
      return codeArr.code
    }
  }
  return code
}

export default {
  namespaced: true,
  state: () => ({
    userInfo: {},
    menuList: [],
    menuMap: {},
    menuBtn: [],
    permissionList: {},
    allMenu: [],
    menuArr: []
  }),
  getters: {
    /**
     * @description 判断是否有菜单按钮权限
     * @param {string} key IT服务台菜单按钮配置的url
     * @returns Boolean
     */
    hasMenuBtnAuth: state => (key) => filterMenuBtn(state.menuBtn, key),
    /**
     * @description 判断拥有哪些数据权限
     * @param {string} url IT服务台菜单url
     * @returns {string} code 返回对应的code 传入后端获取对应数据
     */
    hasMenuDateAuth: state => (url) => filterMenuDataAuth(state.menuArr, url),
    userInfo: state => state.userInfo,
    hasBtnCode: state => (key) => getMenuBtnCode(state.menuBtn, key),
    menuArr: state => state.menuArr,
  },
  mutations: {
    setUserInfo (state, payload = {}) {
      state.userInfo = payload
    },
    setMenuList (state, payload = []) {
      state.menuList = payload
    },
    setMenuMap (state, payload = {}) {
      state.menuMap = payload
    },
    setUserPermission (state, payload = {}) {
      state.permissionList = payload
    },
    // 把菜单转成数组
    setMenuArr (state, payload = {}) {
      state.menuArr = payload
    },
    setAllMenu (state, payload = {}) {
      state.allMenu = payload
      // 清空承载菜单按钮数组
      btnList = []
      // 过滤出所有菜单按钮
      state.menuBtn = filterAllMenuBtn(payload)
    },
  },
  actions: {}
}
